/**
 * The three figures on the sign-in page.
 *
 * The one read on the public router. Counts only — see `impact.service.ts` on
 * the API for what that constrains and why these three are safe to publish.
 */

import { apiGet } from './client';

export interface Impact {
  volunteers: number;
  hours: number;
  programs: number;
}

export function fetchImpact(): Promise<Impact> {
  return apiGet<Impact>('/impact');
}
